export enum PostSubscriptionActionEnum {
  FindPreSubGameShowRun = 'FindPreSubGameShowRun',
  FindPreSubGameShowState = 'FindPreSubGameShowState',
  FindIfIAmRejected = 'FindIfIAmRejected'
}
